function nestedProperty (object, fields) {
  if (fields.length === 0) {
    return object
  }
  const attribute = fields[0]
  if (object[attribute]) {
    return nestedProperty(object[fields[0]], fields.slice(1))
  }
  return nestedProperty(object, fields.slice(1))
}

const isValid = function (...fields) {
  const check = nestedProperty(this.$v, fields.reverse())
  if (!check) {
    return null
  }
  if (check.$dirty === false) {
    return null
  }
  return check.$invalid === false
}

export default {
  methods: {
    isValid
  }
}
